
export * from '../../frontend-js-react-web/__liferay__/exports/react-dom.js';

import __default__ from '../../frontend-js-react-web/__liferay__/exports/react-dom.js';
export default __default__;
